// Operational capacity limits (mirrors backend erp/limits.py — backend is the source of truth).
// These are shown to users BEFORE they pick a file / request an export; the backend enforces them.
export const UPLOAD_LIMITS = {
  material: 20000,
  consumer: 20000,
  opening: 5000,
  backlog: 5000,
  delete: 5000,
  billing: 5000,
};

export const EXPORT_MAX_ROWS = 250000;

export const fmt = (n) => new Intl.NumberFormat("en-IN").format(n);
